import React from 'react';
import { motion } from 'framer-motion';
const standards = [{
  num: '01',
  title: 'CONSULT',
  desc: "Every cut begins with a conversation. We analyze your face shape, hair texture, and lifestyle to craft a style that's uniquely yours."
}, {
  num: '02',
  title: 'CRAFT',
  desc: 'Precision tools. Master techniques. Every fade, every line, every detail executed with surgical accuracy.'
}, {
  num: '03',
  title: 'REFINEMENT',
  desc: 'Hot towel finish. Styling consultation. You leave not just looking sharp — but feeling unstoppable.'
}];
export function SteelStandard() {
  return <section id="standard" className="py-24 md:py-32 relative" data-id="element-138">
      <div className="container mx-auto px-6 md:px-12" data-id="element-139">
        <motion.div className="text-center mb-20" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-140">
          <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-141">
            The Steel Standard™
          </h2>
          <div className="w-24 h-[1px] bg-gold mx-auto" data-id="element-142"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-143">
          {standards.map((item, index) => <motion.div key={item.num} className="glass-card p-10 rounded-sm flex flex-col items-start hover:-translate-y-2 transition-transform duration-500" initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.15
        }} data-id="element-144">
              <span className="text-gold font-serif text-4xl mb-6 opacity-80" data-id="element-145">
                {item.num}
              </span>
              <h3 className="text-xl tracking-[0.15em] uppercase mb-4 font-medium" data-id="element-146">
                {item.title}
              </h3>
              <p className="text-white/60 font-light leading-relaxed" data-id="element-147">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}